import { MapPin, ExternalLink } from "lucide-react";

/**
 * DashboardBrandStrip — compact top strip shown on the Partner / Investor /
 * Admin dashboards. Combines the physical Sahyog Finance signage photo,
 * the tagline, the Vyara office address and a "View location" button that
 * opens Google Maps.
 *
 * Distinct from `BrandBanner.jsx` (which is the huge landing-hero variant).
 */
const OFFICE_ADDRESS_LINES = [
  "A-106, Ambaji Complex,",
  "Ambaji Mata Road, Vyara,",
  "Tapi, Gujarat — 394650",
];
const GOOGLE_MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=A-106%20Ambaji%20Complex%20Ambaji%20Mata%20Road%20Vyara%20Tapi%20Gujarat%20394650";

export default function DashboardBrandStrip() {
  return (
    <section
      data-testid="dashboard-brand-strip"
      className="rounded-2xl border border-[#D4AF37]/30 bg-[#0A1F44] overflow-hidden"
    >
      <div className="grid md:grid-cols-[160px_1fr_auto] gap-0 items-stretch">
        {/* Signage photo */}
        <div className="p-3 flex items-center justify-center bg-[#0A1F44]">
          <img
            src="/brand-signage.jpg"
            alt="Sahyog Finance & Noble Infinity Asset Management"
            className="w-full h-auto max-h-[140px] object-contain rounded-lg"
            data-testid="dashboard-brand-signage-img"
          />
        </div>

        {/* Brand name + address */}
        <div className="p-5 md:p-6 border-t md:border-t-0 md:border-l border-white/10 min-w-0">
          <div className="text-[10px] uppercase tracking-[0.28em] text-[#F0D788]">
            Integrity · Trust · Growth · Prosperity
          </div>
          <div className="mt-2 font-display text-lg md:text-xl text-white leading-snug">
            Sahyog Finance <span className="text-[#D4AF37]">&amp; Noble Infinity</span>
          </div>
          <div className="text-[11px] text-white/55 mt-0.5">Asset Management Pvt. Ltd.</div>
          <div className="mt-3 flex items-start gap-2 text-xs text-white/70 leading-relaxed">
            <MapPin size={14} className="text-[#D4AF37] mt-0.5 shrink-0" />
            <div>
              {OFFICE_ADDRESS_LINES.map((l) => (
                <div key={l}>{l}</div>
              ))}
            </div>
          </div>
        </div>

        {/* View location CTA */}
        <div className="px-5 py-5 md:py-6 md:pr-6 flex md:items-center md:justify-end border-t md:border-t-0 md:border-l border-white/10">
          <a
            data-testid="dashboard-brand-map-link"
            href={GOOGLE_MAPS_URL}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full btn-gold text-xs font-semibold whitespace-nowrap"
          >
            <MapPin size={13} /> View location <ExternalLink size={11} />
          </a>
        </div>
      </div>
    </section>
  );
}
